import React from 'react';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import { TextButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/TextButtonRel';

export const AccountOpeningV2KYCFailureNotLockedOutStepLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack spacing={3} direction="column">
      <ImageRel relationship={resource.relationship(fr.relationships.image.name)} />
      <MetaControlField attr="title" />
      <MetaControlField attr="description" />
      <MetaLayoutRemainingFields noAccordion />
      <FDStack direction="column" alignItems="center" spacing={2}>
        <PrimaryActionButtonRel relationship={resource.relationship(fr.relationships.restart.name)} />
        <TextButtonRel relationship={resource.relationship(fr.relationships.homePage.name)} />
      </FDStack>
    </FDStack>
  );
};
